/* eslint-disable no-unused-vars */

import { DeleteFromUpload } from 'assets/icons';
import { Buttons, Search } from 'components';
import { useComputed } from '@preact/signals-react';

export const SearchAndDelete = ({ searchRef, searchValue$, onDelete, selectedImg$ }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '0 24px',
        width: '800px',
      }}
    >
      {useComputed(() => (
        <Search
          ref={searchRef}
          width={459}
          placeholder='Search by name'
          value={searchValue$.value}
          onChange={(e) => (searchValue$.value = e.target.value)}
          rightIconOnClick={() => (searchValue$.value = '')}
          style={{ height: '48px', width: '100%' }}
        />
      ))}
      <Buttons.TertiarySmall
        id='delete_selected_creative'
        isDisabled={!selectedImg$.value}
        icon={<DeleteFromUpload />}
        onClick={onDelete}
        isDestructive={true}
        style={{ marginLeft: 'auto' }}
      >
        Delete Selected
      </Buttons.TertiarySmall>
    </div>
  );
};
